import React from 'react';
import { useNavigate } from 'react-router';
import {
  Visible,
  Card,
  CardHeader,
  CardSection,
  ParagraphHeader,
  Gutter,
  Form,
  Input,
} from '@axiom/ui';
import type { TalentSearchDisplayFilters } from '@axiom/validation';
import { TalentSearchDisplayFiltersSchema } from '@axiom/validation';

import { TalentSearchFilters } from '../TalentSearchFilters/TalentSearchFilters';
import { TalentSearchFilterUtil } from '../../utils/talent-search-filter-util';
import { WindowUtil } from '../../utils/window-util';
import { CandidateApi } from '../../api/candidate-api';

export interface TalentSearchFiltersFormProps {
  disabled?: boolean;
  displayFilters: TalentSearchDisplayFilters;
}

export const TalentSearchFiltersForm = ({
  disabled,
  displayFilters,
}: TalentSearchFiltersFormProps) => {
  const navigate = useNavigate();
  return (
    <Form
      name="TALENT_SEARCH_FILTERS_FORM"
      schema={TalentSearchDisplayFiltersSchema}
      initialValues={{
        search: displayFilters.search,
        categories: displayFilters.categories,
        sort: displayFilters.sort,
        hasSearched: displayFilters.hasSearched,
      }}
      submitOnChange
      onSubmit={async (_, __, formData) => {
        const { data, isUnderQueryLimit } =
          TalentSearchFilterUtil.getSelectedFilters(formData);
        if (isUnderQueryLimit) {
          void navigate('/browse-talent/page/1');
          WindowUtil.setUrlQuery(data, true);
          await CandidateApi.refreshCandidateSearchResults();
        }
      }}
    >
      {({ values }) => {
        return (
          <Gutter bottom="1rem">
            <Visible only="largeScreen tablet">
              <Card>
                <CardHeader>
                  <ParagraphHeader>Search</ParagraphHeader>
                </CardHeader>
                <CardSection>
                  <Input
                    name="search"
                    placeholder="Search"
                    disabled={disabled}
                    icon="search"
                  />
                </CardSection>
              </Card>
              <Gutter bottom="16px" />
              <Card>
                <CardHeader>
                  <ParagraphHeader>Filters</ParagraphHeader>
                </CardHeader>
                <CardSection>
                  <TalentSearchFilters
                    formData={values as TalentSearchDisplayFilters}
                    disabled={disabled}
                  />
                </CardSection>
              </Card>
            </Visible>
          </Gutter>
        );
      }}
    </Form>
  );
};
